import { Box, Typography, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { colors } from './styles';

/**
 * A reusable notification box component for AIMe feature
 * Can be used for warnings, errors, or other notifications
 * @param {string} type - 'warning' or 'error'
 * @param {string} title - Title text for the notification
 * @param {string|JSX.Element} content - Content text or JSX element for the notification
 * @param {boolean} showContactButton - Whether to show the contact button
 * @param {boolean} isInternalUser - Whether the user is internal
 * @param {string} marginTop - Top margin of the notification box
 * @param {string} width - Width of the notification box
 */
const NotificationBox = ({
  type = 'warning', // 'warning' or 'error'
  title,
  content,
  showContactButton = true,
  isInternalUser = false,
  marginTop = '50px',
  width = '70%',
}) => {
  // Define styles based on type
  const styles = {
    warning: {
      backgroundColor: colors.warning.background,
      borderColor: colors.warning.border,
      iconColor: colors.warning.text,
      buttonColor: colors.warning.button,
      buttonHoverColor: colors.warning.buttonHover,
      icon: '⚠',
    },
    error: {
      backgroundColor: colors.error.background,
      borderColor: colors.error.border,
      iconColor: colors.error.text,
      buttonColor: colors.error.button,
      buttonHoverColor: colors.error.buttonHover,
      icon: '⚠',
    },
  };

  const currentStyle = styles[type] || styles.warning;

  return (
    <Box
      component="div"
      sx={{
        border: `1px solid ${currentStyle.borderColor}`,
        borderRadius: '8px',
        backgroundColor: currentStyle.backgroundColor,
        padding: '15px',
        marginTop,
        width,
        alignSelf: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
        <Box sx={{ color: currentStyle.iconColor }}>
          <span style={{ fontSize: '24px' }}>{currentStyle.icon}</span>
        </Box>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#000000', mb: 1 }}>
            {title}
          </Typography>
          {typeof content === 'string' ? (
            <Typography sx={{ color: '#000000' }}>
              {content}
            </Typography>
          ) : content}
          {showContactButton && (
            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                startIcon={<EmailIcon />}
                href={`mailto:${isInternalUser ? 'pete@altvia.com' : 'support@altvia.com'}`}
                component="a"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  backgroundColor: `${currentStyle.buttonColor} !important`,
                  backgroundImage: 'none !important',
                  '&:hover': {
                    backgroundColor: `${currentStyle.buttonHoverColor} !important`,
                    backgroundImage: 'none !important',
                  },
                }}
              >
                Contact {isInternalUser ? 'Product' : 'Us'}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationBox;
